import { connect } from 'react-redux';
import { ReduxStore } from '../../../store/reducers';
import { withNavBar } from '../../shared/NavBar/NavBar';
import {ObservationsForm } from "../../shared/ObservationsForm/ObservationsForm"
import { IObservationServiceObj } from '../../../shared/apiServices/IApiInterfaces';
import sharedHistory from '../../../shared/History';
import { RouteNames } from '../../../shared/enums/RouteNames';

interface IEditObservationProps {
    userObject: ICognitoUser;
    observationObj: IObservationServiceObj
}

const EditObservations = (props: IEditObservationProps) => {

    // Route back if no observation passed in (i.e. on screen refresh)
    if(!Object.keys(props.observationObj).length) {
        sharedHistory.push(RouteNames.Observations)
        return null;
    }

    return (
        <>
            <ObservationsForm type="edit" observationObj={props.observationObj} isShowTrashCan={props.observationObj?.observedBy?.trim() === props.userObject.attributes?.email?.trim()}/>
        </>
    );
};

const stateToProps = (state: ReduxStore) => {
    return { 
        userObject: state.User.UserObject,
        observationObj: state.Observation.ObservationObject 
    }
}

export default withNavBar(connect(stateToProps)(EditObservations), true);